import { services } from '@broadleaf/admin-components';
const { ComponentRegistrar } = services;
import { default as AuroraTextField } from './AuroraTextField';

ComponentRegistrar.registerFieldComponent('AURORA_TEXT_FIELD', AuroraTextField);
export default AuroraTextField;
